import React from 'react';
import styled from 'styled-components';
import GISonLineLogo from './../images/logo/gisonlineWithMargin.png';

const StyledPoweredWrapper = styled.div`
    width: 100%;
    text-decoration: none;
    color: #757575;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 6px;
`;

const StyledImg = styled.img`
    height: 36px;
    width: auto;
`;

const PoweredInfo = () => {
    return (
        <StyledPoweredWrapper>
            powered by
            <a href="http://www.gisonline.pl/" target="_gisonline">
                <StyledImg
                    src={GISonLineLogo}
                    alt='GISonLine'>
                </StyledImg>
            </a>
        </StyledPoweredWrapper>
    )
};

export default PoweredInfo;



// WEBPACK FOOTER //
// ./src/components/PoweredInfo.jsx